import React from "react";
import PropTypes from "prop-types";
import { Menu, Dropdown, Image, Table, Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as actions from "../../actions/auth";
import {
  getAppBrand,
  getAppLogo,
  updatePageHeaders,
} from "../../utils/PageHelper";

class TopNavigation extends React.Component {
  componentWillMount() {
    if (!this.props.isTokenValid()) {
      this.props.expireSession();
    }
    updatePageHeaders();
  }

  shouldComponentUpdate() {
    if (!this.props.isTokenValid()) {
      this.props.expireSession();
    }
    return true;
  }

  render() {
    const { userAccount } = this.props;
    const appToken = localStorage.appToken;
    return (
      <div className="topnav topnav-color col-lg-12 col-sm-12 col-md-12 border-light">
        <Table className="table-no-border background-color-transparent">
          <Table.Body>
            <Table.Row>
              <Table.Cell width={3} className="float-left">
                <Link to={"/searchoptions"}>
                  <Image
                    src={getAppLogo()}
                    style={{
                      maxHeight: "60px",
                      maxWidth: "200px",
                      padding: "5px",
                    }}
                    className="topnavigation-logo"
                  />
                </Link>
              </Table.Cell>
              <Table.Cell width={9} className="text-center icon-align-middle">
                {getAppBrand()}
              </Table.Cell>
              <Table.Cell width={3}>
                {localStorage.searchUiData && appToken && userAccount && userAccount.acctFirstName && (
                  <div>
                    <Menu
                      secondary
                      pointing
                      className={"margin-bottom-5"}
                      style={{ border: "none" }}
                    >
                      <Menu.Menu>
                        <Dropdown
                          item
                          trigger={
                            userAccount.acctFirstName !== ""
                              ? `Welcome ${userAccount.acctFirstName} ${userAccount.acctLastName}`
                              : "Hello"
                          }
                        >
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() =>
                                this.props.logout(this.props.user.userid)
                              }
                            >
                              Logout
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </Menu.Menu>
                    </Menu>
                    <span>Last login: {userAccount.lastLogin}</span>
                  </div>
                )}
                {!localStorage.searchUiData && appToken && (<div><Button onClick={() =>
                                this.props.logout(this.props.user.userid)
                              }
                               value="Logout">
                                Logout
                              </Button></div>)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}

TopNavigation.propTypes = {
  logout: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  logout: actions.logout,
  isTokenValid: actions.isTokenValid,
  expireSession: actions.expireSession,
})(TopNavigation);



// WEBPACK FOOTER //
// ./src/components/navigation/TopNavigation.js